"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var validation_1 = require("utils/helpers/validation");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('isOpen', 'setIsOpen', true), recompose_1.pure);
var Component = enhance(function (props) {
    var selectedProjectNumber = props.selected && props.selected.type === 'INTERNAL'
        ? props.selected.selectedProject
        : undefined;
    var selectedProject = undefined;
    if (selectedProjectNumber !== undefined &&
        props.selected &&
        props.selected.type === 'INTERNAL' &&
        props.selected.projects) {
        var project = props.selected.projects.filter(function (x) { return x.id === selectedProjectNumber; });
        if (project.length > 0) {
            selectedProject = project.pop();
        }
    }
    if (props.selected &&
        props.selected.type === 'INTERNAL' &&
        props.selected.projects &&
        props.selected.projects.length === 1) {
        selectedProject = props.selected.projects[0];
    }
    var clickable = props.selected &&
        props.selected.type === 'INTERNAL' &&
        props.selected.projects &&
        props.selected.projects.length > 1
        ? true
        : false;
    return (React.createElement(sok_ui_1.Accordion, { isOpen: props.isOpen },
        React.createElement(sok_ui_1.AccordionHeader, { onClick: function () { return props.setIsOpen(!props.isOpen); }, isOpen: props.isOpen }, (0, translation_1.getLocalization)('userfront/billingInformation/ProjectBillingTitle')),
        React.createElement("div", { className: 'project-information' },
            props.selected !== undefined && props.selected.type === 'INTERNAL' && (React.createElement(sok_ui_1.Dropdown2, { clickable: clickable, className: 'select-billing-information' },
                React.createElement(sok_ui_1.TextInput, { className: 'select', editable: false, disabled: props.selected &&
                        props.selected.projects &&
                        props.selected.projects.length === 1, value: selectedProject
                        ? selectedProject.projectName
                        : (0, translation_1.getLocalization)('userfront/billingInformation/selectProject'), iconRight: React.createElement("span", { className: 'icon-container' },
                        React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' })) }),
                props.selected.projects &&
                    props.selected.projects.length !== 0 && (React.createElement(sok_ui_1.Dropdown2Menu, null, props.selected.projects.map(function (x, i) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "project-".concat(i), onClick: function () {
                        var selected = props.selected && props.selected.type === 'INTERNAL'
                            ? __assign(__assign({}, props.selected), { selectedProject: x.id }) : undefined;
                        if (selected) {
                            props.setBillingInformation(selected);
                        }
                    } }, (0, translation_1.getLocalization)(x.projectName))); }))))),
            props.errors && (0, validation_1.getError)('selectedProject', props.errors) && (React.createElement("p", { className: 'form-error' }, (0, validation_1.getError)('selectedProject', props.errors))))));
});
exports.default = Component;
